import { render, staticRenderFns } from "./CompanyAgentsCard.vue?vue&type=template&id=72e49af2&"
import script from "./CompanyAgentsCard.vue?vue&type=script&lang=ts&"
export * from "./CompanyAgentsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports